import { Box, Stack, Typography } from "@mui/material";
import { BUCKET_LABELS, formatDuration } from "./formatDuration";
import type { EvidenceActivitySummary } from "../../types/evidenceActivity";

const COLORS = ["primary.main", "primary.light", "warning.light", "action.selected"];
const pct = (share: number) => `${Math.round(share * 100)}%`;

export default function TimeBuckets({ buckets }: { buckets: EvidenceActivitySummary["buckets"] }) {
  const sorted = [...buckets].sort((a, b) => b.share - a.share);
  return (
    <Box sx={{ mt: 3 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: 1 }}>
        <Typography sx={{ fontSize: 15, fontWeight: 600 }}>Where the time goes</Typography>
        <Typography variant="caption" color="text.disabled">median per package</Typography>
      </Stack>
      <Box role="img" aria-label="Share of time by activity" sx={{ display: "flex", height: 10, borderRadius: 5, overflow: "hidden", bgcolor: "action.hover" }}>
        {sorted.map((b, i) => <Box key={b.bucket} sx={{ width: `${b.share * 100}%`, bgcolor: COLORS[i] }} />)}
      </Box>
      <Stack direction="row" flexWrap="wrap" useFlexGap sx={{ gap: "6px 20px", mt: 1 }}>
        {sorted.map((b, i) => (
          <Typography key={b.bucket} variant="caption" color="text.secondary" sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
            <Box component="span" sx={{ width: 10, height: 10, borderRadius: 0.5, bgcolor: COLORS[i], display: "inline-block" }} />
            {BUCKET_LABELS[b.bucket]} · {formatDuration(b.medianSeconds)} · {pct(b.share)}
          </Typography>
        ))}
      </Stack>
      <Typography variant="caption" color="text.disabled" sx={{ display: "block", mt: 1.5 }}>Time between two steps is charged to the step that follows. Generation wait is excluded.</Typography>
    </Box>
  );
}
